import {useHttp} from "../../../../context/HttpProvider";
import UserDeletedModal from "./UserDeletedModal";

export default function UserDeleted() {
    const {showDeleted} = useHttp();

    return <>
        {showDeleted && <UserDeletedModal />}
    </>
}